<template>

  <div>


    <b-modal v-if="modalEnvironmentItemShow" size="xl" id="modal-checklist-environment-item" no-close-on-esc
             no-close-on-backdrop
             title="Mapeamento de Itens do Ambiente" hide-footer @hide="getTabItems()">

      <EnvironmentItem :foreign-key="environmentId"/>

    </b-modal>

    <b-modal
        v-model="showModalEvidenceOldPhotos"
        title="Fotos de inspeções anteriores"
        size="xl"
        scrollable
        hide-footer
        @hidden="evidenceOldForeignKey = null">

      <h5>{{ evidenceOldDate | datetime }}</h5>
      <div>
        <b-icon icon="person" class="mr-1"></b-icon>
        {{ evidenceOldUser }}
      </div>

      <ChecklistEnvironmentEvidenceFile
          v-if="showModalEvidenceOldPhotos"
          message-not-record="Nenhuma imagem encontrada de outras inspeções para este mesmo ambiente"
          only-view
          type-image
          :foreign-key="evidenceOldForeignKey"
          :business-evidence-file-required-fields="businessEvidenceFileRequiredFields" :business-evidence-file-label-order-fields="businessEvidenceFileLabelOrderFields"/>
    </b-modal>


    <ChecklistEnvironmentItemFormDialog
        :command="form.statusEnvironment === StatusChecklistEnvironmentType.type.FINISHED || statusChecklist === StatusChecklistType.type.FINISHED || command === 'view' ? 'view' : 'update'"
        :primary-key="modalChecklistEnvironmentItemId"
        :set-user-auth="userAuth"
        :enable-compare-checklist="enableCompareChecklist"
        v-if="modalChecklistEnvironmentItemId"
        @onClose="onCloseModalItem"
        @onSubmit="onCloseModalItem"/>

    <ChecklistEnvironmentOccurrenceDialog
        :checklist-item-id="modalOccurrenceItemId"
        :type-checklist-item="modalOccurrenceItemName"
        :checklist-environment-id="form.checklistEnvironmentId"
        :enterprise-id="enterpriseId"
        :occurrence="modalOccurrenceItemOccurrence"
        :business-type-survey="businessTypeSurvey"
        :user-access-budget-show-price="userAccessBudgetShowPrice"
        :set-tab-index="modalOccurrenceItemTabIndex"
        v-if="modalOccurrenceItemShow"
        @onClose="onCloseModalItem"
    />

    <t-blackout white no-close-on-esc no opacity9 v-model="blackout">

      <template #buttons-top>

        <div style="max-width: 950px; margin: auto; width: 90%">

          <b-row>

            <div class="col-12 d-flex justify-content-end align-items-end">
              <b-button class="p-0" variant="link" @click="onClose()">
                <b-icon-x/>
                Fechar
              </b-button>
            </div>

          </b-row>

        </div>

      </template>

      <div style="width: 950px !important;">

        <div class="card-header-tab card-header-tab-animation card-header bg-white"
             style="border-top-left-radius: 5px; border-top-right-radius: 5px; border:solid 1px #ccc; border-bottom: solid 1px #e1e1e1">

          <div class="card-header-title font-size-lg text-capitalize font-weight-normal"
               style="width: 333px; overflow: hidden; margin-right: 50px">
            {{ form.environment }}
          </div>

          <div style="width: 70px; font-size: 12px; text-align: center; font-weight: normal">
            <b-icon-clock v-b-tooltip.hover.ds500
                          :title="getElapsedText(form.startDate,form.finishDate)"/>
            {{ elapsedTime }}
          </div>

          <ul class="nav">

            <li class="nav-item">
              <a data-toggle="tab" :class="{'active':localTab === 1}" @click="onShowTab(1)"
                 class="nav-link show"><span v-if="accountModule === 'estate'">Fotos</span><span
                  v-else>Registro</span></a>
            </li>

            <li class="nav-item"
                v-show="businessTypeSurvey >= SurveyType.type.ESTATE"
            >
              <a data-toggle="tab"
                 :class="{'active':localTab === 2}"
                 @click="onShowTab(2)"
                 class="nav-link show"><span v-if="accountModule === 'estate'">Itens</span><span
                  v-else>Apontamentos</span></a>
            </li>
            <!--            <li class="nav-item" v-show="businessTypeSurvey  >= SurveyType.type.OCCURRENCE">
                          <a data-toggle="tab" :class="{'active':localTab === 3}"
                             @click="onShowTab(3)"
                             class="nav-link show">Planta</a></li>-->
            <!--            <li class="nav-item" v-show="businessTypeSurvey  >= SurveyType.type.OCCURRENCE"><a data-toggle="tab"
                                                                                                           :class="{'active':localTab === 4}"

                                                                                                           @click="onShowTab(4)"
                                                                                                           class="nav-link show">Campos</a>
                        </li>-->
            <li class="nav-item" v-show="enableOccurrence"><a data-toggle="tab"
                                                              :class="{'active':localTab === 5}"
                                                              @click="onShowTab(5)"
                                                              class="nav-link show">Resumo</a>
            </li>


          </ul>

        </div>


        <div class="bg-white p-2 container-blackout-content"
             style="border-left: 1px solid #ccc; border-right: 1px solid #ccc; border-bottom: 1px #ccc solid; min-height: 200px">


          <div v-show="!busy && localTab === 1" class="tab-content-blackout">


            <div style="width: 95%; margin: auto">

              <t-form-card title="Novas" class="border">
                <ChecklistEnvironmentEvidenceFile
                    type-image
                    :only-view="form.statusEnvironment === StatusChecklistEnvironmentType.type.FINISHED || statusChecklist === StatusChecklistType.type.FINISHED"
                    :foreign-key="checklistEnvironmentId"
                    message-not-record="Espaço para fotos, sem vínculo com apontamentos técnicos. Ideal para documentar conformidades, andamento da obra, condições gerais e registros cautelares."
                    :business-evidence-file-required-fields="businessEvidenceFileRequiredFields" :business-evidence-file-label-order-fields="businessEvidenceFileLabelOrderFields"/>
              </t-form-card>

              <t-form-card title="Anteriores" class="border">

                <t-button light small @click="getEvidenceOldChecklistFiles()" class="mb-2">
                  <b-icon-eye v-show="!showEvidenceOldPhotos" class="mr-2"/>
                  <b-icon-eye-slash v-show="showEvidenceOldPhotos" class="mr-2"/>
                  <span v-show="!showEvidenceOldPhotos">Exibir</span>
                  <span v-show="showEvidenceOldPhotos">Ocultar</span>
                </t-button>

                <t-msg info v-show="!showEvidenceOldPhotos">Imagens de outras inspeções realizadas neste mesmo ambiente,
                  cuja inspeção e ambiente estejam finalizados.
                </t-msg>

                <!-- FILTROS -->
                <div class="d-flex align-items-center flex-wrap mb-2" v-if="showEvidenceOldPhotos">

                  <!-- ANO (dinâmico) -->
                  <div class="mr-3 mb-2">
                    <small class="text-muted d-block mb-1">Ano</small>

                    <b-button
                        v-for="y in evidenceYears"
                        :key="'y'+y"
                        size="sm"
                        class="mr-1"
                        :variant="filterYear === y ? 'primary' : 'outline-secondary'"
                        @click="toggleYear(y)"
                    >
                      <b-icon icon="calendar3" class="mr-1"></b-icon>
                      {{ y }}
                    </b-button>
                  </div>

                  <!-- PERÍODO -->
                  <div class="mr-3 mb-2">
                    <small class="text-muted d-block mb-1">Período</small>

                    <b-button
                        v-for="d in [30,60,90]"
                        :key="'d'+d"
                        size="sm"
                        class="mr-1"
                        :variant="filterDays === d ? 'primary' : 'outline-secondary'"
                        @click="toggleDays(d)"
                    >
                      <b-icon icon="clock-history" class="mr-1"></b-icon>
                      {{ d }} dias
                    </b-button>
                  </div>

                  <!-- LIMPAR -->
                  <div class="mb-2">
                    <small class="text-muted d-block mb-1">&nbsp;</small>

                    <b-button
                        v-if="filterYear || filterDays"
                        size="sm"
                        variant="outline-danger"
                        @click="clearFilters"
                    >
                      <b-icon icon="x-circle" class="mr-1"></b-icon>
                      Limpar
                    </b-button>
                  </div>

                </div>


                <b-list-group flush v-if="showEvidenceOldPhotos">
                  <b-list-group-item
                      v-for="(item, index) in evidenceChecklistOldItemsFiltered"
                      :key="index"
                      button
                      class="evidence-item evidence-grid card-hover-shadow hover table-hover"
                      @click="openEvidenceOld(item)"
                      :title="'Abrir fotos desta inspeção'"
                  >
                    <!-- COL 1: Data -->
                    <div class="evidence-col-date">
                      <b-icon icon="clock-history" class="text-muted mr-2"></b-icon>
                      <span class="evidence-date">
        {{ item.logControl.createdDate | datetime }}
      </span>
                    </div>

                    <!-- COL 2: Spacer (respiro visual) -->
                    <div></div>

                    <!-- COL 3: Qtd Fotos -->
                    <div class="evidence-col-photos">
      <span class="badge evidence-badge border">
        <b-icon icon="camera" class="mr-1"></b-icon>
        {{ item.qtyEvidenceFile }}
      </span>
                    </div>

                    <!-- COL 4: Responsável -->
                    <div class="evidence-col-user">
                      <small class="text-muted text-truncate">
                        <b-icon icon="person" class="mr-1"></b-icon>
                        {{ item.logControl.createdUser }}
                      </small>
                    </div>
                  </b-list-group-item>
                </b-list-group>

                <small class="text-muted pt-2" v-if="showEvidenceOldPhotos">
                  Exibindo {{ evidenceChecklistOldItemsFiltered.length }} de {{ evidenceChecklistOldItems.length }}
                </small>



              </t-form-card>

            </div>


          </div>

          <div v-show="!busy && localTab === 2" class="tab-content-blackout">


            <div class="list-group hideHeader">

              <t-msg info
                     v-if="form.statusEnvironment === StatusChecklistEnvironmentType.type.FINISHED">

                <span v-if="objValid(form.processedDate)"> Ambiente inspecionado e sincronizado em {{
                    form.processedDate | datetime
                  }}. Para modificar será necessário estornar a finalização da inspeção e do ambiente </span>
                <span v-else> Ambiente inspecionado, processando as informações no servidor <b-icon-clock-history/></span>

              </t-msg>


              <t-msg info
                     v-if="form.statusEnvironment !== StatusChecklistEnvironmentType.type.FINISHED && statusChecklist === StatusChecklistType.type.FINISHED">
                Ambiente não inspecionado
              </t-msg>

              <b-col cols="12" class="mb-2">

                <b-row>

                  <t-input cols="4" v-model="search.typeChecklistItem" label="Pesquisar Item">
                    <template #input-icon>
                      <b-icon-search/>
                    </template>
                  </t-input>

                </b-row>

                <t-msg info v-show="pageFormIsLoaded && listIsLoaded && items.length === 0">Nenhum ambiente encontrado
                  de acordo com o filtro informado
                </t-msg>

              </b-col>

              <div v-if="!enableOccurrence" class="d-flex justify-content-between">

                <small class="mr-3">Condição Atual</small>

                <small class="mr-3">Condição Anterior
                  <t-help
                      title="Utilizado em inspeções de comparação, onde é exibido o estado anterior, podendo ser confirmado ou modificado."/>
                </small>

              </div>

              <li v-for="(item,index) in onItems"
                  @click="openDialogItem(item)"
                  :key="index"
                  :class="{'checklist-estate':!enableOccurrence}"
                  class="list-group-item list-group-item-form-list flip-list-enter-to">

                <div class="d-flex" style="word-break: break-word;">

                  <div class="text flex-grow-1 mr-1 ml-1" style="word-break: break-word;">

                    <b-row>

                      <b-col cols="8">

                        <div v-if="enableOccurrence"
                             style="width: 7px; height: 100%; position: absolute; left: 0; border-radius: 3px"
                             :class="{
                          'bg-grey':item.statusItem === StatusChecklistItemType.type.PENDING,
                          'bg-success':item.statusItem === StatusChecklistItemType.type.OK,
                          'bg-warning':item.statusItem === StatusChecklistItemType.type.HAS_PENDING_OCCURRENCE,
                          'bg-danger':item.statusItem === StatusChecklistItemType.type.HAS_NEW_OCCURRENCE,
                          }"></div>


                        <div v-else style="width: 7px; height: 100%; position: absolute; left: 0; border-radius: 3px"
                             class="bg-light-alternative"
                             :style="{'background-color':item.typeEstateItemStatusBackgroundColor + '!important'}"></div>

                        <div style="font-size: 15px; line-height: 30px">

                          <b-link v-if="enableOccurrence" v-b-toggle="'accordion-'+index" class="text-dark">
                            {{ item.typeChecklistItem }}
                          </b-link>

                          <div v-else>

                            <div class="text-dark" style="line-height: normal !important;">
                              <span style="font-weight: 600;">{{ item.typeChecklistItem }}</span> {{ item.note }}
                            </div>
                            <div style="line-height: normal !important;"><small>{{ item.typeEstateItemStatus }}</small>
                            </div>
                          </div>


                        </div>

                      </b-col>

                      <b-col cols="4" class="d-flex align-items-center justify-content-center" v-if="enableOccurrence">

                        <b-form-checkbox
                            v-show="(item.statusItem === StatusChecklistItemType.type.PENDING && statusChecklist === StatusChecklistType.type.PENDING)"
                            @change="setItemOk(item.checklistItemId)"
                        >
                          <i class="fa fa-check text-success"></i>
                        </b-form-checkbox>

                        <span v-show="item.statusItem !== StatusChecklistItemType.type.PENDING">

                           <b-badge variant="success" class="mr-2">{{ item.qtyOccurrencesDone }}
                          </b-badge>
                         <b-badge
                             variant="warning" class="mr-2">{{ item.qtyOccurrencesPending }}
                          </b-badge>
                          <b-badge
                              variant="danger">{{ item.qtyOccurrencesNew }}
                          </b-badge>

                        </span>


                      </b-col>

                      <b-col cols="4" class="d-flex align-items-center justify-content-end"
                             v-else-if="enableCompareChecklist">

                        <div
                            style="width: 7px; height: 100%; position: absolute; right: 0; border-radius: 3px"
                            class="bg-light-alternative"
                            :style="{'background-color':item.oldTypeEstateItemStatusBackgroundColor + '!important'}"></div>

                        <div>{{ item.oldTypeEstateItemStatus }}</div>

                      </b-col>

                      <!--                      <b-col cols="1"  v-if="!enableOccurrence">
                                              <div>
                                                <div class="text-danger"><b-icon-arrow-down></b-icon-arrow-down></div>
                                                <div class="text-danger" style="font-size: 10px">Piorou</div>
                                              </div>
                                            </b-col>-->

                    </b-row>

                    <b-row v-if="enableOccurrence">

                      <b-col cols="4" class="dialog-list-line-buttons fade-in2">

                        <b-button-group>

                          <b-button variant="outline-secondary" :disabled="item.occurrences.length === 0"
                                    v-b-toggle="'accordion-'+index" size="sm">
                            <b-icon-card-list/>
                            Detalhar
                          </b-button>
                          <b-button
                              :disabled="form.statusEnvironment === StatusChecklistEnvironmentType.type.FINISHED || statusChecklist === StatusChecklistType.type.FINISHED"
                              :title="form.statusEnvironment === StatusChecklistEnvironmentType.type.FINISHED  || statusChecklist === StatusChecklistType.type.FINISHED ? 'Inclusão desabilitada, pois o ambiente já está sincronizado ou a inspeção está finalizada' : ''"
                              @click="openDialogOccurrence(item,null,0, index)" variant="outline-primary" size="sm">
                            <b-icon-clipboard-plus/>
                            Apontamento
                          </b-button>

                          <!--                          <b-button variant="outline-secondary" size="sm">
                                                      <b-icon-clock-history/>
                                                      Histórico
                                                    </b-button>-->
                        </b-button-group>

                      </b-col>

                    </b-row>

                  </div>

                </div>

                <b-collapse :id="'accordion-'+index" visible
                            accordion="accordion-checklist-items" class="p-2 "
                            style="margin-right: -20px; margin-left: -20px; margin-bottom: -21px; margin-top: 10px; border-bottom: 1px solid #ccc">

                  <div v-if="item.occurrences.length > 0">

                    <b-row v-for="occurrence in item.occurrences" :key="occurrence.checklistItemOccurrenceId"
                           class="pt-1 pb-2"
                           style="margin-right: -8px; margin-left: -8px"
                           :class="{
                          'bg-warning-light':occurrence.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_PENDING,
                          'bg-danger-light':occurrence.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_NEW,
                          'bg-success-light':occurrence.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_CLOSE,
                          }"
                    >

                      <b-col cols="3" class="d-flex align-items-center justify-content-left"
                             style="margin-right: -30px">

                        <!-- <div style="width: 5px; height: 26px; position: absolute; left: 12px; border-radius: 3px"
                                                     class="bg-warning"></div>-->

                        <!-- <div class="mr-2 ml-2"><b>{{ ++index }}</b></div>-->

                        <t-button small
                                  @click="openDialogOccurrence(item,occurrence,0,null)"
                                  danger
                                  v-show="occurrence.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_NEW">

                          <div class="text-center">
                            <b-icon-pencil-square class="mr-2"/>
                            <span>Novo Apontamento</span>
                          </div>

                        </t-button>

                        <t-button small
                                  warning
                                  v-show="occurrence.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_PENDING"
                                  @click="openDialogOccurrence(item,occurrence,0,null)">

                          <div class="text-center">
                            <b-icon-pencil-square class="mr-2"/>
                            <span>Pendente</span>
                          </div>


                        </t-button>

                        <t-button small
                                  success
                                  v-show="occurrence.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_CLOSE"
                                  @click="openDialogOccurrence(item,occurrence,0,index)">


                          <div class="text-center">
                            <b-icon-pencil-square class="mr-2"/>
                            <span>Finalizada</span>
                          </div>
                        </t-button>

                      </b-col>

                      <b-col cols="6">

                        {{ occurrence.typePathologyAutomatically }} ({{ occurrence.sector }})

                        <small>{{ occurrence.typeAnomalyOriginAutomatically }}</small>

                        <div
                            v-if="occurrence.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_NEW">

                          <small class="opacity-6 mr-2" v-if="objValid(occurrence.occurrenceCodeLabel)">
                            <i class="fa fa-info-circle"></i>
                            <span v-if="objValid(occurrence.otherCodeLabel)">{{ occurrence.otherCodeLabel }}</span>
                            <span v-else>{{ occurrence.occurrenceCodeLabel }}</span>
                          </small>

                          <small class="opacity-6">
                            <i class="fa fa-user"></i>
                            {{ occurrence.logControl.createdUser }}
                          </small>
                          <small class="opacity-6 ml-2">
                            <i class="fa fa-calendar-alt"></i>
                            {{ occurrence.logControl.createdDate | datetime }}
                          </small>

                        </div>

                        <div v-else>

                          <small class="opacity-6 mr-2" v-if="objValid(occurrence.occurrenceCodeLabel)">
                            <i class="fa fa-info-circle"></i>
                            <span v-if="objValid(occurrence.otherCodeLabel)">{{ occurrence.otherCodeLabel }}</span>
                            <span v-else>{{ occurrence.occurrenceCodeLabel }}</span>
                          </small>

                          <small class="opacity-6">
                            <i class="fa fa-user"></i>
                            {{ occurrence.occurrenceCreatedUser }}
                          </small>
                          <small class="opacity-6 ml-2">
                            <i class="fa fa-calendar-alt"></i>
                            {{ occurrence.occurrenceCreatedDate | datetime }}

                          </small>


                        </div>

                        <div v-if="businessTypeSurvey === SurveyType.type.BUDGET && occurrence.budgetEnabled">
                          <b-badge variant="success">Orçamento


                          </b-badge>
                        </div>


                      </b-col>

                      <b-col cols="3" class="d-flex justify-content-end align-items-center mt-1">

                        <div>

                          <b-badge variant="danger"
                                   class="mr-3"
                                   v-if="occurrence.typeCriticalityDegree > 1 && occurrence.typeCriticalityLineClass === 'bg-danger-light'">
                            {{ occurrence.typeCriticality }}
                          </b-badge>
                          <b-badge variant="warning"
                                   class="mr-3"
                                   v-else-if="occurrence.typeCriticalityDegree > 1 && occurrence.typeCriticalityLineClass === 'bg-warning-light'">
                            {{ occurrence.typeCriticality }}
                          </b-badge>

                          <b-badge v-if="objValid(occurrence.executorSignaled)" class="mr-3" variant="info">Sinalizada
                            <t-help :title="getSignaledText(occurrence)"/>
                          </b-badge>

                        </div>

                        <t-button small outline-danger class="mr-1"
                                  v-show="occurrence.statusItemOccurrence === StatusChecklistOccurrenceItemType.type.OCCURRENCE_NEW && form.statusEnvironment !== StatusChecklistEnvironmentType.type.FINISHED"
                                  @click="confirmDeleteNewOccurrence(occurrence.checklistItemOccurrenceId)">
                          <i class="nav-link-icon lnr-trash"/>
                        </t-button>

                        <t-button small outline-secondary class="mr-1"
                                  @click="openDialogOccurrence(item,occurrence,1,null)">
                          <i class="nav-link-icon lnr-camera"/>
                          <span v-show="occurrence.qtyPhotos !== undefined && occurrence.qtyPhotos > 0"
                                v-b-tooltip.hover.ds500 :title="'Qtd. novas fotos: ' + occurrence.qtyPhotos"
                                class="badge badge-info badge-pill badge-dot badge-dot-sm"/>
                        </t-button>

                        <t-button small outline-secondary class="mr-1"
                                  @click="openDialogOccurrence(item,occurrence,2,null)">
                          <i class="nav-link-icon lnr-bubble"/>
                          <span v-show="objValid(occurrence.comment)"
                                v-b-tooltip.hover.ds500 title="Novo comentário inserido"
                                class="badge badge-info badge-pill badge-dot badge-dot-sm"/>
                        </t-button>

                        <t-button small outline-secondary style="margin-right: 20px;" @click="infoDevelopment()">
                          <i class="nav-link-icon lnr-map-marker"/>
                        </t-button>


                      </b-col>


                    </b-row>

                  </div>

                  <!--                  <div v-show="item.occurrences.length === 0" class="text-center">

                                      <t-msg info>Nenhum apontamento inserido!<br/>
                                        <b-link
                                            v-if="form.statusEnvironment !== StatusChecklistEnvironmentType.type.FINISHED && statusChecklist === StatusChecklistType.type.PENDING"
                                            @click="openDialogOccurrence(item,null,0, null)">Adicionar apontamento
                                        </b-link>
                                      </t-msg>

                                    </div>-->


                </b-collapse>

              </li>

            </div>

            <div class="d-flex align-items-center justify-content-center p-2 mt-3">
              <b-link @click="openEnvironmentItemDialog"
                      v-if="form.enableSpecificItems && businessAllowEditEnvironment && statusChecklist === StatusChecklistType.type.PENDING">
                <b-icon-map class="mr-1"></b-icon-map>
                Alterar Mapeamento de Itens
              </b-link>
            </div>

            <div class="pt-0 p-2 mt-3" v-if="enableOccurrence">

              Legenda:<br/>

              <table>
                <tr>
                  <td>
                    <div style="width: 5px; height: 15px; border-radius: 3px" class="bg-success"></div>
                  </td>
                  <td class="pl-1">Item sem nenhum apontamento novo ou pendente</td>
                </tr>
                <tr>
                  <td>
                    <div style="width: 5px; height: 15px; border-radius: 3px" class="bg-warning"></div>
                  </td>
                  <td class="pl-1">Item possui pelo menos um apontamento pendente</td>
                </tr>
                <tr>
                  <td>
                    <div style="width: 5px; height: 15px; border-radius: 3px" class="bg-danger"></div>
                  </td>
                  <td class="pl-1">Item com 1 (um) ou mais apontamento(s) aberto(s).</td>
                </tr>


              </table>

            </div>

            <div class="pt-0 p-2 mt-1 mb-2" v-else>

              Legenda:<br/>

              <table>
                <tr>
                  <td>
                    <div style="width: 5px; height: 15px; border-radius: 3px" class="bg-light-alternative"></div>
                  </td>
                  <td class="pl-1">Item pendente para avaliação (caso ficar em cinza será ignorado no relatório)</td>
                </tr>
                <tr>
                  <td>
                    <div style="width: 5px; height: 15px; border-radius: 3px" class="bg-info"></div>
                  </td>
                  <td class="pl-1">Item novo</td>
                </tr>
                <tr>
                  <td>
                    <div style="width: 5px; height: 15px; border-radius: 3px" class="bg-success"></div>
                  </td>
                  <td class="pl-1">Item em ótimo estado</td>
                </tr>
                <tr>
                  <td>
                    <div style="width: 5px; height: 15px; border-radius: 3px" class="bg-warning"></div>
                  </td>
                  <td class="pl-1">Item regular</td>
                </tr>
                <tr>
                  <td>
                    <div style="width: 5px; height: 15px; border-radius: 3px" class="bg-danger"></div>
                  </td>
                  <td class="pl-1">Item danificado/quebrado/mau estado</td>
                </tr>


              </table>

            </div>


          </div>

          <div v-show="!busy && localTab === 3" class="tab-content-blackout">

            <t-msg info>Não utilizada</t-msg>

          </div>

          <div v-show="!busy && localTab === 4" class="tab-content-blackout">


            <validation-observer ref="validationEnvironment">

              <form @submit.prevent autocomplete="off" ref="form" :class="{'form-loading':busy}">

                <t-form-wrapped :command="command" :status="localStatus">


                  <b-col cols="12">

                    <t-msg
                        v-show="!busy && (entityFieldCustomized('typeChecklist') === null || entityFieldCustomized('typeChecklist').length === 0)"
                        info>
                      Não existem campos a serem coletados para esta inspeção, para cadastrar acesse: <br/> 'Inspeções'
                      > 'Configurações' > 'Modelos de Inspeção' e cadastre campos para preenchimento por ambiente. <br/>
                      <br/> Obs.: Este recurso somente é válido quando utilizado modelos de inspeção.
                    </t-msg>

                    <t-page-form-field-customized
                        ref="fieldsEnvironment"
                        :command="command" :status="localStatus" :user-auth="userAuth"
                        :fields-customizable="entityFieldCustomized('typeChecklist')"
                        :primary-key="form.checklistEnvironmentId" :foreign-key="form.typeChecklistId"
                        :busy="busy"
                        primary-key-column="checklistEnvironmentId" foreign-key-column="typeChecklistId"
                    />

                  </b-col>


                </t-form-wrapped>

              </form>

            </validation-observer>


          </div>

          <div v-show="!busy && localTab === 5" class="tab-content-blackout">

            <div class="no-gutters row border-bottom">
              <div class="col-sm-12 col-md-4 col-xl-4">
                <div class="card no-shadow rm-border bg-transparent widget-chart text-left">
                  <div class="icon-wrapper rounded-circle">
                    <div class="icon-wrapper-bg opacity-9 bg-success d-flex align-items-center justify-content-center">
                      <b-icon-clipboard-check style="scale: 1.7" class="text-white"/>
                    </div>

                  </div>
                  <div class="widget-chart-content">
                    <div class="widget-subheading">Apontamentos Finalizadas</div>
                    <div class="widget-numbers text-success">
                      <span>{{ form.qtyItemsOccurrencesDone }}</span></div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-4 col-xl-4">
                <div class="card no-shadow rm-border bg-transparent widget-chart text-left">
                  <div class="icon-wrapper rounded-circle">
                    <div class="icon-wrapper-bg opacity-9 bg-warning d-flex align-items-center justify-content-center">
                      <b-icon-clipboard-minus style="scale: 1.7" class="text-white"/>
                    </div>

                  </div>
                  <div class="widget-chart-content">
                    <div class="widget-subheading">Apontamentos Pendentes</div>
                    <div class="widget-numbers">{{ form.qtyItemsOccurrencesPending }}</div>
                  </div>
                </div>
                <div class="divider m-0 d-md-none d-sm-block"></div>
              </div>
              <div class="col-sm-6 col-md-4 col-xl-4">
                <div class="card no-shadow rm-border bg-transparent widget-chart text-left">
                  <div class="icon-wrapper rounded-circle">

                    <div class="icon-wrapper-bg opacity-9 bg-danger d-flex align-items-center justify-content-center">
                      <b-icon-clipboard-plus style="scale: 1.7" class="text-white"/>
                    </div>


                  </div>
                  <div class="widget-chart-content">
                    <div class="widget-subheading">Apontamentos novas</div>
                    <div class="widget-numbers"><span>{{ form.qtyItemsOccurrencesNew }}</span></div>
                  </div>
                </div>
                <div class="divider m-0 d-md-none d-sm-block"></div>
              </div>

            </div>


            <div style="max-height: calc(100vh - 450px); overflow-y: auto">

              <b-row style="width: 100%; margin: auto"
                     v-show="dashboard.pathology !== undefined && dashboard.pathology.length > 0">

                <b-col cols="6">


                  <div style="max-height: 250px; overflow-y: auto" class="mt-3">

                    <table class="align-middle table table-borderless table-striped table-hover">
                      <thead>
                      <tr>
                        <th class="text-center"></th>
                        <th>Ranking Anomalias</th>
                        <th class="text-center">Qtd.</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(pathology,index) in dashboard.pathology" :key="pathology.typePathologyId">
                        <td class="text-center text-muted">{{ ++index }}º</td>
                        <td>
                          <div style="font-size: 14px">{{ pathology.typePathology }}</div>

                          <div class="d-flex align-items-center justify-content-start border b-radius">
                            <div class="mb-2 ml-2 mt-2 mr-2 badge badge-dot badge-dot-xl"
                                 :style="{'background-color': pathology.sectorColor}"></div>
                            <div class="small">{{ pathology.sector }}</div>
                          </div>

                        </td>

                        <td class="text-center">
                          {{ pathology.qtyRecords }}
                        </td>
                      </tr>

                      </tbody>
                    </table>

                  </div>


                </b-col>

                <b-col cols="6">

                  <apexchart type="pie" class="mt-4" :options="chartSectorOptions" v-if="chartSectorSeries.length > 0"
                             :series="chartSectorSeries"></apexchart>

                </b-col>

              </b-row>

              <b-row style="width: 100%; margin: auto"
                     v-show="dashboard.criticality !== undefined && dashboard.criticality.length > 0">

                <b-col cols="6">


                  <div style="max-height: 250px; overflow-y: auto" class="mt-3">

                    <table class="align-middle table table-borderless table-striped table-hover">
                      <thead>
                      <tr>
                        <th class="text-center"></th>
                        <th>Ranking Criticidade</th>
                        <th class="text-center">Qtd.</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(criticality,index) in dashboard.criticality" :key="criticality.typeCriticalityId">
                        <td class="text-center text-muted"
                            :class="{[criticality.typeCriticalityLineClass] : criticality.typeCriticalityLineClass !== '' }">
                          {{ ++index }}º
                        </td>
                        <td>
                          <div style="font-size: 14px" :style="{'color': criticality.typeCriticalityColor}">
                            {{ criticality.typeCriticality }}
                          </div>

                        </td>

                        <td class="text-center">
                          {{ criticality.qtyRecords }}
                        </td>
                      </tr>

                      </tbody>
                    </table>

                  </div>


                </b-col>

                <b-col cols="6">

                  <apexchart type="pie" class="mt-4" :options="chartCriticalityOptions"
                             v-if="chartCriticalitySeries.length > 0" :series="chartCriticalitySeries"></apexchart>

                </b-col>

              </b-row>

            </div>


          </div>


        </div>


        <b-row>

          <div class="col-12 d-flex z-index-6"

               v-if="form.statusEnvironment === StatusChecklistEnvironmentType.type.STARTED">

            <div class="bg-light container_blackout_footer_button">

              <t-button class="mt-2"
                        @click="onSubmit"
                        submit-fake
                        :sending="localStatus === 'sending'"
                        primary :text="'Finalizar Ambiente'"/>
            </div>

          </div>

        </b-row>

      </div>

    </t-blackout>

  </div>

</template>

<script>
import ui from "@/assets/scripts/ui";
import http from "@/services/config/http-common";
import StatusChecklistItemType from "@/model/types/modules/checklist/StatusChecklistItemType";
import StatusChecklistEnvironmentType from "@/model/types/modules/checklist/StatusChecklistEnvironmentType";
import StatusChecklistOccurrenceItemType from "@/model/types/modules/checklist/StatusChecklistOccurrenceItemType";
import ChecklistEnvironmentOccurrenceDialog
  from "@/views/modules/checklist/Checklist/ChecklistEnvironmentOccurrenceDialog";
import ChecklistEnvironmentEvidenceFile from "@/views/modules/checklist/Checklist/ChecklistEnvironmentEvidenceFile";
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin";
import pageFormMixin from "@/mixins/page/pageFormMixin";
import StatusChecklistType from "@/model/types/modules/checklist/StatusChecklistType";
import SurveyType from "@/model/types/modules/checklist/SurveyType";
import ChecklistEnvironmentItemFormDialog from "@/views/modules/checklist/Checklist/ChecklistEnvironmentItemFormDialog";
import EnvironmentItem from "@/views/modules/place/EnvironmentItem";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'ChecklistEnvironmentItemDialog',
  components: {
    ChecklistEnvironmentOccurrenceDialog,
    ChecklistEnvironmentEvidenceFile,
    ChecklistEnvironmentItemFormDialog,
    EnvironmentItem
  },
  data() {
    return {
      SurveyType,
      StatusChecklistType,
      StatusChecklistEnvironmentType,
      StatusChecklistItemType,
      StatusChecklistOccurrenceItemType,
      path: "checklist/item",
      blackout: false,
      localTab: 1,
      busy: false,
      elapsedTime: "",
      dashboard: {},
      accordionState: false,
      modalChecklistEnvironmentItemShow: false,
      modalChecklistEnvironmentItemId: 0,
      modalEnvironmentItemShow: false,
      modalOccurrenceItemShow: false,
      modalOccurrenceItemId: 0,            /* checklistItemId */
      modalOccurrenceItemName: ""          /*typeChecklistItem*/,
      modalOccurrenceItemOccurrence: {},  /* checklistItemOccurrenceId */
      modalOccurrenceItemTabIndex: 0,      /*Tab para exibição por padrão*/
      modalOccurrenceItemOpenAccordion: null,
      items: [],
      form: {},
      search: {
        typeChecklistItem: "",
      },
      command: "insert",
      accountModule: "",
      enableOccurrence: false,
      localStatus: "",
      showEvidenceOldPhotos: false,
      showModalEvidenceOldPhotos: false,
      evidenceOldForeignKey: 0,
      evidenceOldDate: null,
      evidenceOldUser: null,
      evidenceChecklistOldItems: [],
      filterYear: null,       // ex: 2026
      filterDays: null,        // ex: 30, 60, 90
      fieldsCustomizable: [
        {
          entity: "typeChecklist",
          foreignKeyColumn: "typeChecklistId",
          path: "checklist/type-model-environment",
          fields: [],
        }
      ],
      chartSectorSeries: [],
      chartSectorOptions: {
        chart: {
          width: 200,
          type: 'pie',
        },
        colors: [],
        labels: [],
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
        },
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        },
      },
      chartCriticalitySeries: [],
      chartCriticalityOptions: {
        chart: {
          width: 200,
          type: 'pie',
        },
        colors: [],
        labels: [],
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
        },
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        },
      },
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    userAccessBudgetShowPrice: {
      type: Boolean,
      default: false,
    },
    businessAllowEditEnvironment: Boolean,
    businessEvidenceFileRequiredFields: String,
    businessEvidenceFileLabelOrderFields: String,
    enableCompareChecklist: Boolean,
    enterpriseId: Number,
    businessTypeSurvey: Number,
    showTab: Number, /*Muda o numero da tab desejada para exibição do padrã*/
    checklistEnvironmentId: Number,
    environmentId: Number,
    statusChecklist: Number,
  },

  methods: {

    //--------------------------------------------------------------------------------------
    async onShowTab(number) {

      this.localTab = number

      if (this.localTab === 1) {
        await this.getTabItems()
      } else if (this.localTab === 3) {
        await this.getTabMark()
      } else if (this.localTab === 5) {
        await this.getTabResume()
      }

    },

    async getChecklistEnvironment(getFields = false) {

      await http.get('checklist/environment/' + this.checklistEnvironmentId).then(async response => {

        this.form = response.data

        if (this.objValid(this.form.finishDate)) {
          this.command = "view"
        }

        if (getFields) {

          if (this.objValid(this.form.typeChecklistId)) {

            if (this.form.typeChecklistId > 0 && this.fieldsCustomizable.length > 0) {

              for (const entity of this.fieldsCustomizable) {

                await this.getFieldsCustomizable(entity.entity)
              }

            }
          }
        }

      }).catch(error => ui.generalResponseError(this, error))

    },

    async getDashboard() {

      await http.get('checklist/environment/dashboard/' + this.checklistEnvironmentId).then(response => {

        this.dashboard = response.data

        this.chartSectorOptions.labels = []
        this.chartSectorOptions.colors = []
        this.chartSectorSeries = []

        this.chartCriticalityOptions.labels = []
        this.chartCriticalityOptions.colors = []
        this.chartCriticalitySeries = []

        for (const item of this.dashboard.sector) {

          this.chartSectorOptions.labels.push(item.sector)
          this.chartSectorOptions.colors.push(item.sectorColor)
          this.chartSectorSeries.push(item.qtyRecords)

        }

        for (const item of this.dashboard.criticality) {

          let color = item.typeCriticalityColor

          if (color === null || color === '') {
            color = "#ccc"
          }

          this.chartCriticalityOptions.labels.push(item.typeCriticality)
          this.chartCriticalityOptions.colors.push(color)
          this.chartCriticalitySeries.push(item.qtyRecords)

        }

      }).catch(error => ui.generalResponseError(this, error))

    },

    openEnvironmentItemDialog() {

      this.modalEnvironmentItemShow = true
      this.openModal('modal-checklist-environment-item')

    },

    async onSubmit() {

      //Por padrão irá enviar o comando para finalizar o ambiente
      this.form.finish = true

      //Avisa o pai que mudou o status para submetido
      this.localStatus = "subject"
      this.$parent.status = "subject"

      this.$refs.validationEnvironment.validate().then(async success => {

        if (!success) {
          ui.msgErrorForm(this, this.$refs.validationEnvironment)
          this.localTab = 4
          return;
        }

        //console.log('Form validação básica padrão passou!')
        await http.get("checklist/environment/checkIsFinished/" + this.checklistEnvironmentId).then(async () => {


          ui.msgConfirm(this, '', 'Tem certeza que deseja finalizar a inspeção deste ambiente:<br /><b>' + this.form.environment + '</b>', async () => {

            this.localStatus = "sending"

            //Verifica se alguma regra será aplicada
            await this.injectFieldsForm()

            await http.put("checklist/environment", this.form).then(async () => {
              ui.toast(this, 'Sucesso', 'Ambiente inspecionado com sucesso!')
              this.onClose()
            }).catch(error => ui.generalResponseError(this, error))


          }, 'Finalizar')

        }).catch(error => {
          this.localTab = 1
          ui.generalResponseError(this, error)

        })


      });

    },


    async getTabItems(loading = true) {

      this.modalEnvironmentItemShow = false

      if (loading)
        this.busy = true

      await this.getChecklistEnvironment()

      await http.list(this.path + "?checklistEnvironmentId=" + this.checklistEnvironmentId + "&returnOccurrences=true").then(list => {
        this.items = list

        if (loading)
          this.busy = false
      }).catch(error => ui.generalResponseError(this, error))

    },

    getElapsedText(startDate, finishDate) {
      if (startDate !== '' && this.objValid(finishDate)) {
        return 'Iniciado em: ' + ui.convertDateBR(startDate, true) + ' - finalizado em: ' + ui.convertDateBR(finishDate, true)
      } else {
        return 'Iniciado em: ' + ui.convertDateBR(startDate, true)
      }
    },

    openDialogItem(item) {

      if (!this.enableOccurrence) {

        this.modalChecklistEnvironmentItemShow = true
        this.modalChecklistEnvironmentItemId = item.checklistItemId
        this.openModal('modal-checklist-environment-item-form')

      }

    },

    hexToRgba(hex, alpha = 0.05) {

      if (hex !== undefined && hex !== null) {

        hex = hex.replace('#', '');
        if (hex.length === 3) {
          hex = hex.split('').map(c => c + c).join('');
        }
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;

      }

    },

    async getTabMark() {

      this.busy = true

      setTimeout(() => {

        this.busy = false
      }, 200)

    },
    async getTabResume() {

      this.busy = true

      setTimeout(async () => {

        await this.getChecklistEnvironment()
        await this.getDashboard()

        this.busy = false
      }, 200)

    },

    onClose() {

      this.$emit('onClose')
      this.blackout = false

    },


    startTime() {

      if (this.objValid(this.form.startDate)) {

        let startDate = new Date(this.form.startDate)

        if (this.form.statusEnvironment === StatusChecklistEnvironmentType.type.FINISHED) {

          const finishDate = new Date(this.form.finishDate)
          let elapsedTime = (finishDate.getTime() - startDate.getTime())

          const time = new Date(elapsedTime).toISOString().slice(11, 19)

          if (time === "23:59:59") {
            elapsedTime = 'Iniciado em: ' + ui.convertDateBR(startDate, true)
          } else {
            elapsedTime = time
          }

          this.elapsedTime = elapsedTime


        } else {

          const today = new Date();
          let elapsedTime = (today.getTime() - startDate.getTime())

          const time = new Date(elapsedTime).toISOString().slice(11, 19)

          if (time === "23:59:59") {
            elapsedTime = 'Iniciado em: ' + ui.convertDateBR(startDate, true)
          } else {
            elapsedTime = time
          }

          this.elapsedTime = elapsedTime

        }

        //Continua somente se estiver aberto
        if (this.blackout && this.form.statusEnvironment !== StatusChecklistEnvironmentType.type.FINISHED && this.statusChecklist !== StatusChecklistType.type.FINISHED)
          setTimeout(this.startTime, 1000);

      }

    },
    async setItemOk(checklistItemId) {

      await http.post(this.path + "/setOk/" + checklistItemId, '').then(async () => {
        await this.getTabItems(false)
      }).catch(error => ui.generalResponseError(this, error))

    },

    getSignaledText(occurrence) {
      return 'Sinalizado que foi feito em :<br />' + ui.convertDateBR(occurrence.executorSignaled, true)
    },

    confirmDeleteNewOccurrence(checklistItemOccurrenceId) {

      ui.msgConfirm(this, '', 'Deseja excluir esta novo apontamento?', async () => {

        await http.remove('checklist/item/occurrence', checklistItemOccurrenceId).then(() => {
          this.getTabItems(false)
        }).catch(error => ui.generalResponseError(this, error));

      }, 'Excluir')

    },

    async auxDialogOccurrence(item, occurrence, tabIndex, openAccordion) {

      this.modalOccurrenceItemShow = true
      this.modalOccurrenceItemId = item.checklistItemId
      this.modalOccurrenceItemName = item.typeChecklistItem
      this.modalOccurrenceItemOccurrence = occurrence
      this.modalOccurrenceItemTabIndex = tabIndex
      this.modalOccurrenceItemOpenAccordion = openAccordion

      this.openDialogForm('modal-checklist-item-occurrence', '')

    },

    async openDialogOccurrence(item, occurrence, tabIndex, openAccordion) {

      if (occurrence === null && (item.qtyOccurrencesNew !== undefined && item.qtyOccurrencesNew !== null && item.qtyOccurrencesNew > 0)) {

        let msgConfirm = 'Já existe uma novo apontamento inserido, deseja adicionar mais uma apontamento no mesmo item?'

        if (item.qtyOccurrencesNew > 1) {
          msgConfirm = 'Já existem ' + item.qtyOccurrencesNew + ' novos apontamentos inseridos, deseja adicionar mais um apontamento no mesmo item?'
        }

        ui.msgConfirm(this, '', msgConfirm, () => {
          this.auxDialogOccurrence(item, occurrence, tabIndex, openAccordion)
        })

      } else {
        this.auxDialogOccurrence(item, occurrence, tabIndex, openAccordion)
      }

    },

    async onCloseModalItem(wasChanged) {

      this.modalOccurrenceItemShow = false
      this.modalChecklistEnvironmentItemShow = false

      await this.getTabItems(false)

      if (this.modalOccurrenceItemOpenAccordion !== null && wasChanged && !this.accordionState) {
        //this.$root.$emit('bv::toggle::collapse', 'accordion-' + this.modalOccurrenceItemOpenAccordion)
        //this.modalOccurrenceItemOpenAccordion = null
      }

    },

    async getEvidenceOldChecklistFiles() {

      this.showEvidenceOldPhotos = !this.showEvidenceOldPhotos

      console.log('showEvidenceOldPhotos', this.showEvidenceOldPhotos)

      if (this.showEvidenceOldPhotos) {

        await http.get('checklist/environment/getAllToEvidenceFileOld/' + this.checklistEnvironmentId).then(async response => {

          this.evidenceChecklistOldItems = response.data

        }).catch(error => ui.generalResponseError(this, error))

      }

    },

    openEvidenceOld(item) {
      this.evidenceOldForeignKey = item.checklistEnvironmentId
      this.evidenceOldDate = item.logControl.createdDate
      this.evidenceOldUser = item.logControl.createdUser
      this.showModalEvidenceOldPhotos = true
    },

    getYearUTC(dateValue) {
      if (!dateValue) return null
      const d = new Date(dateValue)
      if (isNaN(d.getTime())) return null
      return d.getUTCFullYear()
    },

    diffDaysUTC(dateValue) {
      if (!dateValue) return null
      const d = new Date(dateValue)
      if (isNaN(d.getTime())) return null

      const now = new Date()

      // zera em UTC para comparação consistente
      const start = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())
      const end = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())

      return Math.floor((end - start) / (1000 * 60 * 60 * 24))
    },

    toggleYear(y) {
      // se clicar no mesmo ano, desmarca
      if (this.filterYear === y) {
        this.filterYear = null
        return
      }

      // selecionou um ano => limpa período
      this.filterYear = y
      this.filterDays = null
    },

    toggleDays(d) {
      // se clicar no mesmo período, desmarca
      if (this.filterDays === d) {
        this.filterDays = null
        return
      }

      // selecionou um período => limpa ano
      this.filterDays = d
      this.filterYear = null
    },

    clearFilters() {
      this.filterYear = null
      this.filterDays = null
    }

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.$root.$on('bv::collapse::state', (collapseId, state) => {
      this.accordionState = state
    })

    this.accountModule = ui.getAccountModule()

    this.blackout = this.value

    this.busy = true

    this.showEvidenceOldPhotos = false
    this.showModalEvidenceOldPhotos = false

    await this.getChecklistEnvironment(true)

    if (this.businessTypeSurvey >= SurveyType.type.OCCURRENCE && this.businessTypeSurvey !== SurveyType.type.ESTATE) {
      this.enableOccurrence = true
    }

    this.busy = false

    this.startTime()


  },
  watch: {

    value(v) {
      this.blackout = v
    },

    blackout(v) {
      this.onShowTab(this.localTab)
      this.$emit("input", v)
    }

  },
  computed: {

    onItems() {

      let filteredItems = this.items

      // Remove acentuação da busca
      const searchValue = ui.removeAccentuation(this.search.typeChecklistItem).toLowerCase();

      // Aplica o filtro para cada campo com 'search' preenchido
      filteredItems = filteredItems.filter(item => {
        const itemValue = item.typeChecklistItem ? ui.removeAccentuation(item.typeChecklistItem).toLowerCase() : '';
        return itemValue.includes(searchValue);
      });

      return filteredItems

    },

    evidenceYears() {
      const years = {}
      for (const item of (this.evidenceChecklistOldItems || [])) {
        const y = this.getYearUTC(item.logControl && item.logControl.createdDate)
        if (y) years[y] = true
      }
      // desc (2026, 2025, 2024...)
      return Object.keys(years).map(n => parseInt(n, 10)).sort((a, b) => b - a)
    },

    evidenceChecklistOldItemsFiltered() {
      const list = (this.evidenceChecklistOldItems || [])

      return list.filter((item) => {
        const created = item.logControl && item.logControl.createdDate

        // filtro por ano
        if (this.filterYear) {
          const y = this.getYearUTC(created)
          if (y !== this.filterYear) return false
        }

        // filtro por dias
        if (this.filterDays) {
          const days = this.diffDaysUTC(created)
          if (days == null) return false
          if (days > this.filterDays) return false
        }

        return true
      })
    }

  }
}
</script>
<style>
.dialog-list-line-buttons {
  visibility: visible;
  opacity: 0.7;
  transition: opacity ease-in-out 0.2s;
}

.list-group-item:hover .dialog-list-line-buttons {
  opacity: 0.9;
  visibility: visible;
}

.container-blackout-content {
  min-height: calc(100vh - 250px) !important;
  max-height: calc(100vh - 250px) !important;
}

.tab-content-blackout {
  margin-top: 15px;
  min-height: calc(100vh - 280px) !important;
  max-height: calc(100vh - 280px) !important;
  overflow-y: auto;
  padding-bottom: 15px;
}

.checklist-estate:hover {
  background-color: rgb(255, 255, 235) !important;
  cursor: pointer;
}

.evidence-grid {
  display: grid;
  grid-template-columns: 220px 1fr 80px 240px;
  align-items: center;
  column-gap: 12px;
}

.evidence-col-date {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.evidence-col-photos {
  text-align: center;
}

.evidence-col-user {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.evidence-date {
  font-weight: 600;
}
</style>

